export default "__VITE_ASSET__CTmfpKzg__"